let resumeData = {
  imagebaseurl: "https://rbhatia46.github.io/",
  name: "Meng-Han(Henry) Chung",
  email: "henry5405@gmail.com",
  linkedinId: " Meng-Han Chung",
  role: "Application Developer",
  skypeid: "henry5405",
  roleDescription: " with 8 years of professional experience in web application development, including 3 years at University Health Services, Florida State University.",
  socialLinks: [
    {
      name: "instagram",
      url: "https://www.instagram.com/powerlifter_henry/",
      className: "fa fa-instagram"
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/meng-han-chung-henry/",
      className: "fa fa-linkedin"
    },
    {
      name: "github",
      url: "https://github.com/Henry-Chung",
      className: "fa fa-github"
    },
    {
      name: "twitter",
      url: "http://twitter.com/HenryChung4",
      className: "fa fa-twitter"
    }
  ],
  aboutmeFirstHalf:
    "Hey there! I'm Meng-Han, but you can call me Henry. I'm a Christian and I've found a great home here in Tallahassee, Florida. I earned my Master's in Computer Science from FSU, where I really honed my love for coding and tackling complex problems. By day, I'm an Application Developer at University Health Services, FSU, and I also serve as a USA Powerlifting Federation referee. From 2019-2020, I had the privilege of serving as President of the Taiwanese Student Association at FSU. When I'm not immersed in code, you'll likely find me powerlifting or enjoying a good movie. Always happy to chat if you have any questions!",
  address: "Tallahassee, Florida, USA",
  website: "https://henry-chung.github.io/MyPage/",
  education: [
    {
      UniversityName: "Florida State University",
      specialization: "Master of Science in Computer Science",
      MonthOfPassing: "May",
      YearOfPassing: "2020",
      Achievements:
        "Teaching Assistant in Computer Science department, President of Taiwanese Student Asscoiation"
    },
    {
      UniversityName: "Yuan Ze University",
      specialization: "Bachelor of Information Management",
      MonthOfPassing: "Jun",
      YearOfPassing: "2013",
      Achievements:
        "Head of Activity Planning in SunFlower Children Service Club"
    }
  ],
  work: [
    {
      CompanyName: "University Health Services at FSU",
      specialization: "Application Developer",
      Starting:"Oct. 2023",
      Leaving: "Present",
      Achievement1:
        "Developed and deployed applications using Razor Page to improve work efficiency of University Health Services",
      Achievement2:
        "Implemented and managed Azure DevOps CI/CD pipelines for automated application delivery and configured IIS Win-ACME for secure certificate lifecycle management",
      Achievement3:
        "Developed and maintained the Insurance Adjustment Portal website, used by more than 40,000 students"
    },
    {
      CompanyName: "Insilicom, LLC",
      specialization: "Software Engineer",
      Starting:"Sep. 2020",
      Leaving: "Oct. 2023",
      Achievement1:
        "Developed a visualized knowledge graph interaction network by using Cytoscape.js.",
      Achievement2:
        "Used the Python web framework, Django, creating the Application Programming Interface (API).",
      Achievement3:
        "Maintained and advanced the Biomedical Knowledge Discovery Engine."
    },
    {
      CompanyName: "FSU Computer Science Department",
      specialization: "Teaching Assistant",
      Starting:"Aug. 2019",
      Leaving: "May. 2020",
      Achievement1:
        "Hosted the office hours for two graduate courses, Data Mining, and Data Computer Communication.",
      Achievement2:
        "Assisted for grading assignments and provided the testing cases and sample codes for students Demo.",
      Achievement3:
        "Mentored 20+ students for basic concepts of Python."
    },
    {
      CompanyName: "Lion Technology CO., LTD",
      specialization: "Software Engineer",
      Starting:"Jun. 2015",
      Leaving: "Apr. 2016",
      Achievement1:
        "Developed and Integrated Enterprise Resource Planning (ERP) system, used by over 3,350 employees, with C# and ASP.NET MVC framework.",
      Achievement2:
        "Maintained and developed new functions for Business-to-Business(B2B), Business to Consumer(B2C) websites.",
      Achievement3:
        "Developed several Application Programming Interface (API) which data in JSON or XML format is received from multiple hotel chains to assist clients in the booking process. "
    },
    {
      CompanyName: "Systemweb Technology",
      specialization: "Software Engineer",
      Starting:"Jun. 2014",
      Leaving: "May. 2015",
      Achievement1:
        "Used JQuery mobile and agile framework Scrum to develop a website.",
      Achievement2:
        "Advanced and maintained websites including global corporations e.g., Prudential and Allianz Global Investors.",
      Achievement3:
        "Integrated Windows Forms applications and Crystal Reports by using C#."
    }
  ],
  skillsDescription: "Your skills here",
  skills: [
    {
      skillname: "Python"
    },
    {
      skillname: "C#"
    },
    {
      skillname: "Java"
    },
    {
      skillname: "C/C++"
    },
    {
      skillname: "VB"
    },
    {
      skillname: "HTML/CSS"
    },
    {
      skillname: "Javascript/JQuery"
    },
    {
      skillname: "Django"
    },
    {
      skillname: "React"
    },
    {
      skillname: "Angular"
    },
    {
      skillname: "MS SQL/MySQL"
    },
    {
      skillname: "MongoDB"
    },

  ]
};

export default resumeData;
